import React, {Fragment, useState} from "react";
import Container from "@material-ui/core/Container";
import BadAnswered from "./responses/BadAnswered";
import Blocked from "./responses/Blocked";
import Unknown from "./responses/Unknown";
import CssBaseline from "@material-ui/core/CssBaseline";
import Button from "@material-ui/core/Button";
import {makeStyles} from "@material-ui/core/styles";
import HTTPClient from "../HTTPClient";
import Loading from "./Loading";
import NotInMeetingRoll from "./responses/NotInMeetingRoll";
import Late from "./responses/Late";
import Typography from "@material-ui/core/Typography";
import AskPhone from "./responses/AskPhone";
import {getMessage} from "../util";

const useStyles = makeStyles(theme => ({
        paper: {
            marginTop: theme.spacing(4),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },

        challenge: {
            marginTop: theme.spacing(4),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        question: {
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(1)
        },
        checkboxLabel: {
            marginBottom: theme.spacing(1),
            marginLeft: theme.spacing(1)
        },
        grid: {
            alignItems: 'center',
        },
        form: {
            width: '100%', // Fix IE 11 issue.
            marginTop: theme.spacing(1)
        },
        submit: {
            margin: theme.spacing(3, 0, 2),
        },
        title: {
            fontSize: '1.2rem',
            color: 'rgba(0, 0, 0, 0.54)',
            marginBottom: theme.spacing(2)
        }
    }
));

const Challenges = (props) => {
    const classes = useStyles();

    const responses = props.challenges.challenges.questions.questions.reduce((acc, elem) => {
        acc[elem.id] = null;
        return (acc);
    }, {});

    const [status, setStatus] = useState('ok');
    const [loading, setLoading] = useState(false);
    const [jwt, setJwt] = useState(null);
    const [reason, setReason] = useState(null);
    const [myMistake, setMyMistake] = useState(false);
    const [wrongCounter, setWrongCounter] = useState(0);

    const login = () => {
        setStatus('ok');

        const data = {
            rut: props.challenges.rut,
            serial: props.challenges.serial,
            meeting_id: props.meeting.slug
        }


        setLoading(true);
        HTTPClient({
            method: "post",
            data: data,
            url:
                process.env.REACT_APP_API_URL +
                "/login/get_questions"
        })
            .then(response => {
                setLoading(false);
                switch (response.data.status) {
                    case 'ok':
                        document.getElementById("theform").reset();
                        props.setChallenges({
                            rut: props.challenges.rut,
                            serial: props.challenges.serial,
                            challenges: response.data
                        });
                        return;
                    case 'wrong':
                        setJwt(response.data.message);
                        setReason("segundo intento con serial malo en respuestas");
                        setStatus('askphone');
                        setMyMistake(true);
                        // setStatus('wrongSerial');
                        return;
                    case 'blocked':
                        setJwt(response.data.message);
                        setReason("bloqueado");
                        setStatus('askphone');
                        //setMyMistake(true);
                        //setStatus('blocked');
                        return;
                    case 'temporarily_blocked':
                        setJwt(response.data.message);
                        setReason("temporalmente bloqueeado");
                        setStatus('askphone');
                        //setStatus('temporarily_blocked');
                        return;
                    case 'noquestions':
                        setJwt(response.data.message);
                        setReason("no pudo generar preguntas");
                        setStatus('askphone');
                        //setStatus('noquestions');
                        return;
                    case 'onlypeople':
                        setStatus('onlypeople');
                        return;
                    case 'safeconduct':
                            window.location = (props.meeting ? '/meeting' : '/');
                        return;
                    default:
                        setJwt(response.data.message);
                        setReason("error desconocido");
                        setStatus('askphone');
                        // setStatus('unknown');
                        return;
                }
            })
            .catch((error) => {
                setLoading(false);
            });

    };


    const answer = (event) => {
        event.preventDefault();

        if (!Object.keys(responses).reduce((acc, elem) => {
            return (acc && responses[elem] != null);
        }, true)) {
            alert(getMessage(props.meeting.meeting_type,'challenges_must_answer',props.messages));
            return;
        }

        const data = {
            "jwt": props.challenges.challenges.message,
            "idchallenge": props.challenges.challenges.questions.idchallenge,
            "answers": Object.keys(responses).map(key => {
                return ({name: key, value: responses[key]});
            })
        }


        setLoading(true);
        HTTPClient({
            method: "post",
            data: data,
            url:
                process.env.REACT_APP_API_URL +
                "/login/verify_answers"
        })
            .then(response => {
                setLoading(false);
                switch (response.data.status) {
                    case 'ok':
                        window.location = (props.meeting ? '/meeting'  : '/');

                        return;
                    case 'wrong':
                        console.log("WRONG",wrongCounter);
                        if (wrongCounter > 0) {
                            setJwt(response.data.message);
                            setReason("segundo intento con respuestas malas");
                            setStatus('askphone');

                        } else {
                            setWrongCounter(wrongCounter+1);
                            setStatus('wrongAnswered');
                        }
                        return;
                    case 'blocked':
                        setJwt(response.data.message);
                        setReason("segundo intento con serial malo");
                        setStatus('askphone');
                        //setMyMistake(true);

                        //setStatus('blocked');
                        return;
                    case 'notfound':
                        setStatus('notfound');
                        return;
                    case 'quorum':
                        setStatus('late');
                        return;
                    default:
                        setJwt(response.data.message);
                        setReason("segundo intento con serial malo");
                        setStatus('askphone');
                        setMyMistake(true);
                        //setStatus('unknown');
                        return;
                }
            })
            .catch((error) => {
                setLoading(false);
            });

    }

    const handleClose = () => {
        setStatus('ok');
        props.setChallenges(null);
    }

    const handleChange = (event) => {
        responses[event.target.name] = event.target.value;
    }

    return (
        <Container component="main" maxWidth="xs">
            {status === 'wrongAnswered' && <BadAnswered meeting={props.meeting} messages={props.messages} open={status === 'wrongAnswered'} handleClose={() => login()}/>}
            {status === 'blocked' && <Blocked meeting={props.meeting} messages={props.messages}  open={status === 'blocked'} handleClose={handleClose}/>}
            {status === 'unknown' && <Unknown meeting={props.meeting} messages={props.messages}  open={status === 'unknown'} handleClose={handleClose}/>}
            {status === 'notfound' && <NotInMeetingRoll  messages={props.messages}  open={status === 'notfound'} handleClose={handleClose} meeting={props.meeting}/>}
            {status === 'late' && <Late messages={props.messages}  open={status === 'late'} handleClose={handleClose} meeting={props.meeting}/>}
            {status === 'askphone' && <AskPhone meeting={props.meeting} messages={props.messages} reason={reason} jwt={jwt} my_mistake={myMistake} handleClose={handleClose} />}

            <CssBaseline/>
            <div className={classes.paper}>

                <div variant="h5" className={classes.title}>
                    {getMessage(props.meeting.meeting_type,'challenges_answer',props.messages)}
                </div>
                <form className={classes.form} noValidate id={"theform"}>
                    <input type="hidden" name="idchallenge" value={props.challenges.challenges.questions.idchallenge}/>
                    {props.challenges.challenges.questions.questions.map(q => (
                        <Fragment key={q.id}>
                            <Typography variant={"h5"} className={classes.question} >{q.question}</Typography>
                            {q.options.map(o => (
                            <Typography key={o.id}>
                                <input type="radio" id={o.id}  name={q.id} value={o.id} onClick={handleChange}/>
                                <label htmlFor={o.id} className={classes.checkboxLabel}>{o.option}</label>
                            </Typography>
                            ))}
                        </Fragment>

                    ))}






                    {loading ? (
                        <Loading/>
                    ) : (
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                            onClick={answer}
                        >
                            {getMessage(props.meeting.meeting_type,'challenges_answer_button',props.messages)}
                        </Button>
                    )}

                    <Button
                        type="submit"
                        variant="outlined"
                        onClick={() => {
                            props.setChallenges(null);
                        }
                        }
                    >
                        {getMessage(props.meeting.meeting_type,'cancel',props.messages)}
                    </Button>
                </form>
            </div>


        </Container>

    );
}

export default Challenges;